/**
 * Footer Effect Module
 * Mouse-follow reveal effect for the footer section
 */
import gsap from 'gsap';

export function initFooterEffect() {
    const footerEffect = document.querySelector('.footer-effect');
    const duplicate = document.querySelector('.footer-effect .duplicate');

    if (!footerEffect || !duplicate) {
        return;
    }

    // Modifies the CSS variable --xpercent with smooth animation
    const xTo = gsap.quickTo(duplicate, '--xpercent', {
        duration: 0.4,
        ease: "back"
    });

    // Modifies the CSS variable --ypercent with smooth animation
    const yTo = gsap.quickTo(duplicate, '--ypercent', {
        duration: 0.4,
        ease: "back"
    });

    footerEffect.addEventListener("mousemove", (e) => {
        // Maps the mouse's X position from the window width range (0 to innerWidth)
        // to a normalized range (0 to 100)
        const mRangeX = gsap.utils.mapRange(0, window.innerWidth, 0, 100, e.clientX);

        // Update the X position smoothly
        xTo(mRangeX);

        // Maps the mouse's Y position relative to the element's bounding box
        // to a normalized range (0 to 100)
        const bound = footerEffect.getBoundingClientRect();
        const mRangeY = gsap.utils.mapRange(bound.top, bound.top + bound.height, 0, 100, e.clientY);

        // Update the Y position smoothly
        yTo(mRangeY);
    });
}
